import { logRenderingError } from '@nbx/log-rendering-error';
import React, { Suspense } from 'react';
import { ServiceProvider } from '@nbx/frontend-helpers/services';
import { ConfigProvider } from '@nbx/config';
import App from './App';

export default class MainRoot extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true });
    logRenderingError(error, info);
  }

  render() {
    if (this.state.hasError) return null;
    return (
      <Suspense fallback={React.Fragment}>
        <ConfigProvider>
          <ServiceProvider card referral>
            <App />
          </ServiceProvider>
        </ConfigProvider>
      </Suspense>
    );
  }
}
